<template>
  <v-card class="d-flex align-center" tile flat min-height="150">
    <v-row no-gutters>
      <v-col cols="12" md="6" class="d-flex align-center justify-center justify-md-start mb-3">
        <v-card outlined>
          <ToggleWishListItemIcon :productId="item.product_id" />
          <v-img v-if="item.product.image" :src="item.product.image" :alt="item.product.name" width="200" height="150" contain>
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-img :src="require('@/assets/img-placeholder.png')" />
              </v-row>
            </template>
          </v-img>
          <v-img v-else :src="require('@/assets/img-placeholder.png')" :alt="item.product.name" width="200" height="150" contain />
        </v-card>
      </v-col>
      <v-col cols="12" md="6" class="d-flex align-center justify-center justify-md-end">
        <v-row no-gutters>
          <v-col cols="12" md="12" class="d-flex align-center justify-center justify-md-start">
            <div class="body-heading-medium text-md-start text-center">{{ item.product.name }}</div>
          </v-col>
          <v-col cols="12" md="12" class="d-flex align-center justify-center justify-md-start">
            <div>Product ID: {{ item.product_id }}</div>
          </v-col>
          <v-col cols="12" md="12" class="d-flex align-center justify-center justify-md-start">
            <div>
              Point Value: <span>{{ item.product.points }}</span>
            </div>
          </v-col>
          <v-col cols="12" md="12" class="text-center text-md-left">
            <RemoveCartItemModal :itemId="item.id" class="mt-6" />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
  import ToggleWishListItemIcon from "@/components/WishList/ToggleWishListItemIcon";
  import RemoveCartItemModal from "./RemoveCartItemModal";

  export default {
    name: "CartListItem",

    props: {
      item: {
        type: Object,
        required: true,
      },
    },

    components: { ToggleWishListItemIcon, RemoveCartItemModal },
  };
</script>



// WEBPACK FOOTER //
// src/components/Cart/CartListItem.vue